import { FC, useState } from "react";
import { InputType } from "../../../types/InputType";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { UserDTO } from "../../../domain/models/dto/UserDTO";
import BaseModal from "../../modals/BaseModal";
import FilterIconSVG from "../../shared/svg/FilterIconSVG";
import CustomInput from "../../../custom-components/form-inputs/CustomInput";
import { usersSearchFiltersFields } from "../../../validation-schemas/UsersSearchFiltersFields";
import CustomDropdown from "../../../custom-components/form-inputs/CustomDropdown";
import { Role } from "../../../domain/enums/RoleEnum";
import { enumToSelectPropsWithoutTranslation } from "../../../tools/EnumTools";

interface UsersSearchFiltersFormProps {
    form: FormikProps<UserDTO>;
    filtersFields: UserDTO;
}

const UsersSearchFiltersForm: FC<UsersSearchFiltersFormProps> = (props) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const confirmHandler = () => {
        setIsVisible(false);
        props.form.handleSubmit();
    };
    const closeHandler = () => {
        props.form.resetForm();
    };
    const onOpenHandler = () => {
        props.form.setValues(props.filtersFields);
    };
    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={t("console.common.filters")}
            confirmTitle={t("console.common.apply")}
            cancelTitle={t("console.common.cancel")}
            buttonElement={
                <button
                    data-modal-target="static-modal"
                    data-modal-toggle="static-modal"
                    className="flex items-center text-white bg-light-bg-300 dark:bg-dark-bg-300 hover:bg-light-bg-300 dark:hover:bg-dark-bg-300 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2.5 text-center max-h-10"
                    type="button"
                    title={t("console.common.filters")}
                    onClick={() => setIsVisible(true)}
                >
                    <FilterIconSVG className="w-[20px] fill-white" />
                </button>
            }
            confirmHandler={confirmHandler}
            closeHandler={closeHandler}
            onOpen={onOpenHandler}
            additionalWrapClassName="w-[450px]"
        >
            <CustomInput
                type={usersSearchFiltersFields.email.type as InputType}
                value={props.form.values.email}
                name="email"
                placeholderKey={usersSearchFiltersFields.email.placeholderKey}
                errorKey={props.form.errors.email as string}
                onChange={props.form.handleChange}
            />
            <CustomDropdown
                data={enumToSelectPropsWithoutTranslation(Role)}
                dropDownCallback={(value) => props.form.setFieldValue("roleId", +value)}
                placeHolderKey={usersSearchFiltersFields.roleId.placeholderKey}
                errorKey={props.form.errors.roleId as string}
                wrapperClassName="mb-6"
                buttonClassName="w-[190px]"
                dropdownClassName="w-[190px]"
            />
            <CustomInput
                type={usersSearchFiltersFields.firstName.type as InputType}
                value={props.form.values.firstName}
                name="firstName"
                placeholderKey={usersSearchFiltersFields.firstName.placeholderKey}
                errorKey={props.form.errors.firstName as string}
                onChange={props.form.handleChange}
            />
            <CustomInput
                type={usersSearchFiltersFields.lastName.type as InputType}
                value={props.form.values.lastName}
                name="lastName"
                placeholderKey={usersSearchFiltersFields.lastName.placeholderKey}
                errorKey={props.form.errors.lastName as string}
                onChange={props.form.handleChange}
            />
            <CustomInput
                type={usersSearchFiltersFields.middleName.type as InputType}
                value={props.form.values.middleName}
                name="middleName"
                placeholderKey={usersSearchFiltersFields.middleName.placeholderKey}
                errorKey={props.form.errors.middleName as string}
                onChange={props.form.handleChange}
            />
            <CustomInput
                type={usersSearchFiltersFields.phone.type as InputType}
                value={props.form.values.phone}
                name="phone"
                placeholderKey={usersSearchFiltersFields.phone.placeholderKey}
                errorKey={props.form.errors.phone as string}
                onChange={props.form.handleChange}
            />
        </BaseModal>
    );
};

export default UsersSearchFiltersForm;
